<template>
  <!-- MODAL -->
  <div
    class="modal fade"
    id="listar-textos-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="margin-top: 30px"
    @click.self="cancelModal"
    @keydown.esc="cancelModal"
  >
    <form @submit.prevent>
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <!-- textos_padrao -->
            <div class="card card-primary">
              <div class="card-body table-responsive p-0" id="list_textos_padrao">
                <table class="table table-hover text-nowrap" style="position: relative">
                  <thead>
                    <tr>
                      <th>Título</th>
                      <th>Conteúdo</th>
                      <th>Editar</th>
                      <th>Deletar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(texto_padrao, index) in textos_padrao" :key="texto_padrao">
                      <td>{{ texto_padrao.titulo }}</td>
                      <td>{{ getFormatedTitle(texto_padrao.conteudo) }}</td>
                      <td>
                        <button type="button" class="btn btn-primary" @click="(texto_selecionado = texto_padrao), (editar_texto_padrao = true)">
                          Editar
                        </button>
                      </td>
                      <td><button type="button" class="btn btn-danger" @click="deletar(texto_padrao)">Deletar</button></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="card-footer clearfix">
                <!-- TOTAIS  -->
                <div style="font-size: 13px" class="float-left" aria-live="polite">
                  Exibindo do {{ inicio + 1 }} ao {{ inicio + textos_padrao.length }}
                  <p>Total {{ total }}</p>
                </div>

                <p class="card-title" style="font-size: 12px; color: black; margin-right: 5px; margin-left: 10px">Por página</p>

                <select
                  @change="alterarQtdPagina()"
                  class="float-left card-titlecustom-select rounded-0"
                  style="font-size: 12px"
                  v-model="qtd_por_pagina"
                >
                  <option :value="1">1</option>
                  <option :value="2">2</option>
                  <option :value="7">7</option>
                  <option :value="15">15</option>
                  <option :value="25">25</option>
                </select>

                <div class="card-tools">
                  <div class="input-group input-group-sm" style="width: 150px"></div>
                </div>

                <!-- PAGINAÇÃO  -->
                <ul class="pagination pagination-sm m-0 float-right">
                  <li class="page-item"><a class="page-link" href="#list_textos_padrao" @click="selecionarPagina(pagina_atual - 1)">&laquo;</a></li>

                  <li v-for="pagina in paginas" :key="pagina" :value="pagina" class="page-item">
                    <a
                      href="#list_textos_padrao"
                      :class="pagina === pagina_atual ? 'page-link current-page' : 'stopped'"
                      class="page-link"
                      @click="selecionarPagina(pagina)"
                    >
                      {{ pagina }}
                    </a>
                  </li>

                  <li class="page-item"><a class="page-link" href="#list_textos_padrao" @click="selecionarPagina(pagina_atual + 1)">&raquo;</a></li>
                </ul>
              </div>

              <div class="card-footer">
                <button type="submit" class="btn btn-primary" @click="validateFields()" style="margin-right: 15px">Cadastrar</button>

                <button class="btn btn-danger" @click="this.setListarTextos(false)">Fechar</button>
                <button hidden data-toggle="modal" data-target="#listar-textos-modal" id="fechar_listar_texto_modal" class="btn btn-danger">
                  Fechar 2
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <admin-editar-texto-padrao
    v-if="editar_texto_padrao"
    :setEditarTexto="setEditarTexto"
    :textoEditado="textoEditado"
    :texto_selecionado="texto_selecionado"
  />
</template>

<script>
import sweetAlert from "../../controller/sweetAlert.js";
import Swal from "sweetalert2/dist/sweetalert2.js";
import AuxController from "../../mixins/auxController.js";
import Loading from "vue-loading-overlay";
import moment from "moment";
import "vue-loading-overlay/dist/vue-loading.css";
import Editor from "primevue/editor";
import { required } from "../../locales/i18n.js";
import { computed, reactive } from "vue";
import useVueLidate from "@vuelidate/core";

export default {
  props: ["setListarTextos"],

  mixins: [sweetAlert, Swal, AuxController],

  components: { Loading, Editor },

  data() {
    return {
      isLoading: false,
      paginas: [],
      total: 0,
      inicio: 0,
      qtd_por_pagina: 25,
      pagina_atual: 1,
      mail_selecionado: "",
      assunto: "",
      corpo: "",
      corpo_text: "",
      texto_teste: "",
      cco: "",
      to: "",
      mail_templates: "",
      data_teste: "Testando data",
      texto_selecionado: "",
      editar_texto_padrao: false,
      textos_padrao: [],
    };
  },

  setup() {
    const formData = reactive({
      titulo: "",
      conteudo: "",
    });

    const rules = computed(() => {
      let local_rules = { titulo: { required }, conteudo: { required } };

      return local_rules;
    });

    const minDate = (date) => {
      return new Date(date) >= new Date();
    };

    const v$ = useVueLidate(rules, formData);

    return { formData, v$ };
  },

  mounted() {
    console.log("Listando textos");

    document.getElementById("fechar_listar_texto_modal").click();

    this.buscarTextosPadrao();
  },

  methods: {
    getFormatedTitle(title) {
      if (title && title.length > 28) {
        return title.substring(0, 28) + "...";
      } else {
        return title;
      }
    },

    textoEditado(data) {
      let btn = document.getElementById("fechar_editar_texto");

      btn.click();

      this.buscarTextosPadrao();

      this.setEditarTexto(false);
    },

    setEditarTexto(value, close_list) {
      if (close_list) {
        this.cancelModal();
      }

      let btn = document.getElementById("fechar_editar_texto");

      if (btn) {
        btn.click();
      }

      this.editar_texto_padrao = false;
    },

    buscarTextosPadrao() {
      let data = {
        inicio: this.inicio,
        tamanho: 10000,
      };

      axios
        .post(`/admin/texto_padrao/search`, data)
        .then((response) => {
          this.textos_padrao = response.data.textos_padrao;
          this.total = response.data.total;

          console.log("Textos buscados");
          console.log(response.data);

          this.pagination(response.data);
        })
        .catch((error) => {
          this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
          console.log(error.response.data);
        });
    },

    pagination(data) {
      this.paginas = [];

      let length = data.total / this.qtd_por_pagina;
      let i = 0;

      //DEFININDO MÁXIMO E MÍNIMO DE PÁGINAS
      if (length < 0) {
        length = 0;
      } else if (length > 10) {
        if (this.pagina_atual >= 10) {
          let minimo = this.pagina_atual - 10;

          if (length - this.pagina_atual > 10) {
            length = this.pagina_atual + 10;
            i = minimo;
          } else {
            i = this.pagina_atual - 10 + (length - this.pagina_atual);
          }
        } else {
          length = 10;
        }
      }

      for (i; i < length; i++) {
        this.paginas.push(i + 1);
      }
    },

    cancelModal() {
      this.setListarTextos(false);
    },

    async validateFields() {
      const result = await this.v$.$validate();

      if (result) {
        this.store();
      }
    },

    deletar(texto_selecionado) {
      this.$swal
        .fire({
          title: "<h3 style='color:#616060'>Esta ação é irreversível, deseja continuar?</h3>",
          icon: "warning",
          padding: "1.5em",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, quero deletar!",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;

            let data = {
              id: texto_selecionado.id,
            };

            console.log("Deletar");
            console.log(data);

            axios
              .post(`/admin/texto_padrao/delete`, data)
              .then((response) => {
                this.showSuccessMessage("Texto deletado!");
                this.buscarTextosPadrao();
              })
              .catch((error) => {
                this.showErrorMessageWithButtonAndRefresh("Ops..", error.response.data);
                console.log(error.response.data);
              });
          }
        });
    },

    store() {
      this.isLoading = true;

      let data = {
        titulo: this.formData.titulo,
        conteudo: this.formData.conteudo,
      };

      console.log("Cadastrando");
      console.log(data);

      axios
        .post(`/admin/texto_padrao/store`, data)
        .then((response) => {
          this.isLoading = false;

          this.showSuccessMessage("Sucesso", "Texto cadastrado");

          this.textoCriado(data);
        })
        .catch((error) => {
          this.isLoading = false;
          this.showErrorMessageWithButton("Ops..", error);
          console.log(error);
        });
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
  },
};
</script>

<style scoped>
.modal-content {
  width: 1000px;
  margin-left: -150px;
}

@media screen and (max-width: 1200px) {
  .modal-content {
    width: 800px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 800px) {
  .modal-content {
    width: 600px;
    margin-left: -50px;
    margin-bottom: 100px;
  }
}

@media screen and (max-width: 600px) {
  .modal-content {
    width: 100%;
    margin-left: 0;
    margin-bottom: 100px;
  }
}
</style>
